
import { BusinessUnitEntityDecorator } from './business-unit.decorator';
import { BusinessUnit } from './business-unit.model';
import { CrudTypeInfo } from '@scisys-uim/uim-common';


export abstract class BusinessUnitTypeInfoBase implements CrudTypeInfo<BusinessUnit, string> {
  name = 'Business Unit';
  entityDecorator = new BusinessUnitEntityDecorator();
  
  createAuthorities = ['WRITE_BUSINESS_UNIT'];
  editAuthorities = ['WRITE_BUSINESS_UNIT'];
  deleteAuthorities = ['WRITE_BUSINESS_UNIT'];
  viewAuthorities = ['READ_BUSINESS_UNIT'];
  
  searchRouteBase = ['/businessunit/search'];
  createRouteBase = ['/businessunit/create'];
  editRouteBase = ['/businessunit/edit'];
  viewRouteBase = ['/businessunit/view'];
  
  description(item: BusinessUnit): string {
    return '' +  item.buId +  ' - ' +  item.name;
  }
}



